import * as Plugins from './plugins'
import { EditorContext, PluginConfig, PluginFactory } from './plugins/types'

const LIVE_EDITOR_PLUGINS: Array<PluginConfig> = [
  Plugins.configData, // must be loaded first
  Plugins.blockInfo,
  Plugins.actSlugTracker, // depends on blockInfo
  Plugins.docInfo,
  Plugins.revisions,
  Plugins.markChanges,
  Plugins.collabUpdate,
  Plugins.characterAutocomplete,
  Plugins.characterContds,
  Plugins.removeStructuralPagination,
  Plugins.removeFormatInfo,
  Plugins.inputRules,
  Plugins.splitPoints,
  Plugins.inlineManualPageBreaks,
  Plugins.inlinePageBreaks,
  Plugins.relaxedSideWidgetHandler,
  Plugins.inkInputRules,
  Plugins.titlePageView,
  Plugins.nextBlock,
  Plugins.emptyBlockCycle,
  Plugins.editorKeymap,
  Plugins.elementPickerKeymap,
  Plugins.inkKeymap,
  Plugins.baseKeymap,
  Plugins.remoteCollaborators,
  Plugins.idMaker,
  Plugins.indentationStyles,
  Plugins.historyPlugin,
  Plugins.comments,
  Plugins.elementNumbers,
  Plugins.syntaxHighlighting,
  Plugins.decorateSelection,
  Plugins.scrollManager,
  Plugins.recordDomPositionsPlugin,
  Plugins.recordLastPosition,
  Plugins.paginationPlugin,
  Plugins.ensureNewline,
  Plugins.focusLock, // last, so Tab handlers above it run first
]

const storageKey = (pluginKey: string) => `omit-plugin:${pluginKey}`
const enablePlugin = (context: EditorContext, pluginConfig: PluginConfig) => {
  if (window.localStorage.getItem(storageKey(pluginConfig.key))) {
    return false
  }

  if (pluginConfig.checkEnabled && !pluginConfig.checkEnabled(context)) {
    return false
  }
  return true
}

export const getLiveEditorPlugins = (
  editorContext: EditorContext,
): PluginFactory[] => {
  return LIVE_EDITOR_PLUGINS.filter((p) => enablePlugin(editorContext, p)).map(
    (p) => p.plugin,
  )
}
